import { render } from "./TheTitle.vue?vue&type=template&id=db7bddbe&scoped=true"
import script from "./TheTitle.vue?vue&type=script&lang=js"
export * from "./TheTitle.vue?vue&type=script&lang=js"

import "./TheTitle.vue?vue&type=style&index=0&id=db7bddbe&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db7bddbe"]])

export default __exports__